import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

interface NotificationAction {
  duration?: number;
  label?: string;
  closable?: boolean;
}

@Injectable()
export class NotificationService {
  public defaultCloseAction: NotificationAction;
  constructor(private snackBar: MatSnackBar, private translate: TranslateService) {}

  open(message: string, messageValues = {}, action: NotificationAction = null) {
    const modifiedNotificationAction =
      action && action.closable ? { ...this.getDefaultCloseAction(), ...action } : action;
    this.translate.get(message, messageValues).subscribe(translatedMessage => {
      this.snackBar.open(translatedMessage, modifiedNotificationAction ? modifiedNotificationAction.label : null, {
        duration: modifiedNotificationAction ? modifiedNotificationAction.duration : 3000,
        horizontalPosition: 'center'
      });
    });
  }

  dismiss() {
    this.snackBar.dismiss();
  }

  getDefaultCloseAction() {
    this.translate.get('CLOSE').subscribe(message => {
      this.defaultCloseAction = {
        label: message,
        duration: 0
      };
    });

    return this.defaultCloseAction;
  }
}
